import { ReactElement } from 'react';
import { ActionLink } from '@lib/components/ActionLink';
import { ICON_NAME, ICON_SIZE } from '@lib/components/Icon';
import { Props } from './BackButton.types';

export const BackButton = ({ url, children, className }: Props): ReactElement => (
  <ActionLink className={className} iconName={ICON_NAME.arrowLeft} iconSize={ICON_SIZE.xsmall} href={url}>
    {children}
  </ActionLink>
);
